export default __webpack_public_path__ + "static/media/RiverAdventurer.b5c79b64.ttf";